import { createContext, useContext } from 'react';
export const ProductPropertiesContext = /*#__PURE__*/createContext(undefined);
export const useProductProperties = () => {
  const context = useContext(ProductPropertiesContext);
  if (context === undefined) {
    throw new Error('ProductPropertiesContext data is undefined. useProductProperties must be used within a ProductPropertiesContext');
  }
  return context;
};